import { render, staticRenderFns } from "./purchaseReceiptTemplate.vue?vue&type=template&id=1347b866&scoped=true"
import script from "./purchaseReceiptTemplate.vue?vue&type=script&lang=js"
export * from "./purchaseReceiptTemplate.vue?vue&type=script&lang=js"
import style0 from "./purchaseReceiptTemplate.vue?vue&type=style&index=0&id=1347b866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347b866",
  null
  
)

export default component.exports